<template>
  <div v-if="data" class="row-box">
    <WrapperField
      v-for="(value, index) in locationOption"
      :key="value + index + Math.random()"
      :data="createDataField({fieldName: index, fieldValue: value, fieldGroup: 'locationStep'})"
    ></WrapperField>
  </div>
</template>

<script>
import { createDataField } from '@/utils/fullStatementView';
import WrapperField from '@/components/elements/statement/FullStatementView/base/WrapperField';

export default {
  name: 'StepSign',
  components: {
    WrapperField,
  },
  props: ['data'],
  data: () => ({
    createDataField,
  }),
  computed: {
    locationOption() {
      return {
        notaryName: this.data.notaryName,
        regionName: this.data.regionName,
      };
    },
  },
};
</script>
